
import { YoungQuestion } from '@/types/personality';

// Questions for Other-Directedness Domain
export const otherDirectednessQuestions: YoungQuestion[] = [
  // Esquema: Subjugação
  {
    id: 34,
    text: "Sempre permiti que outras pessoas escolhessem por mim, então não sei realmente o que quero para mim mesmo.",
    domain: "other_directedness",
    schema: "subjugation"
  },
  {
    id: 35,
    text: "Tenho grande dificuldade em exigir que meus direitos sejam respeitados e que meus sentimentos sejam levados em consideração.",
    domain: "other_directedness",
    schema: "subjugation"
  },
  {
    id: 36,
    text: "Coloco as necessidades dos outros acima das minhas, caso contrário, me sinto culpado.",
    domain: "other_directedness",
    schema: "subjugation"
  },
  
  // Esquema: Autossacrifício
  {
    id: 37,
    text: "Sou a pessoa que geralmente acaba cuidando das pessoas próximas a mim.",
    domain: "other_directedness",
    schema: "self_sacrifice"
  },
  {
    id: 38,
    text: "Não importa o quão ocupado eu esteja, sempre encontro tempo para ajudar os outros.",
    domain: "other_directedness",
    schema: "self_sacrifice"
  },
  {
    id: 39,
    text: "Estou sempre pronto para me responsabilizar pelos problemas dos outros.",
    domain: "other_directedness",
    schema: "self_sacrifice"
  },
  
  // Esquema: Busca de Aprovação
  {
    id: 40,
    text: "Minha autoestima baseia-se primeiramente no que os outros pensam de mim.",
    domain: "other_directedness",
    schema: "approval_seeking"
  },
  {
    id: 41,
    text: "Ter dinheiro e conhecer pessoas importantes me faz sentir valioso.",
    domain: "other_directedness",
    schema: "approval_seeking"
  },
  {
    id: 42,
    text: "Dou mais importância à aprovação dos outros do que aos meus próprios desejos.",
    domain: "other_directedness",
    schema: "approval_seeking"
  }
];
